/** The prospect fields a customer's display name is built from (account-management's snake_case). */
export interface NamedProspect {
  company_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}

/** A customer's name as ops reads it: the company for a business, otherwise first and last name. */
export const customerName = (prospect: NamedProspect | null | undefined): string | null =>
  prospect?.company_name || [prospect?.first_name, prospect?.last_name].filter(Boolean).join(" ") || null;
